import "./injecaoPlastico.css";
import React, { useState, useCallback, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleChevronLeft,
  faCircleChevronRight,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Import para idiomas

import logoInjecaoPlastico from "../../imagens/logos/logoInjecao.png"; 
import logoPlasticPartsEn from "../../imagens/logos/logoPlasticPartsEn.png"; // Logo inglês

function ImgInjecaoPlastico({ listaInjecaoPlastico }) {
  const { i18n, t } = useTranslation(); // Hook i18next
  const [slideNumber, setSlideNumber] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  // Escolhe logo conforme idioma
  const logoImg = i18n.language === "en" ? logoPlasticPartsEn : logoInjecaoPlastico;

  const handleOpenModal = (index) => {
    setSlideNumber(index);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const prevSlide = useCallback(() => {
    slideNumber === 0
      ? setSlideNumber(listaInjecaoPlastico.length - 1)
      : setSlideNumber(slideNumber - 1);
  }, [slideNumber, listaInjecaoPlastico.length]);

  const nextSlide = useCallback(() => {
    slideNumber + 1 === listaInjecaoPlastico.length
      ? setSlideNumber(0)
      : setSlideNumber(slideNumber + 1);
  }, [slideNumber, listaInjecaoPlastico.length]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      switch (event.key) {
        case "Escape":
          handleCloseModal();
          break;
        case "ArrowLeft":
          prevSlide();
          break;
        case "ArrowRight":
          nextSlide();
          break;
        default:
          break;
      }
    };

    if (openModal) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [openModal, nextSlide, prevSlide]);

  return (
    <div>
      {openModal && (
        <div className="injecaoPlasticoSliderWrap">
          <FontAwesomeIcon
            icon={faCircleChevronLeft}
            className="injecaoPlasticoBtnPrev"
            onClick={prevSlide}
          />

          <FontAwesomeIcon
            icon={faCircleChevronRight}
            className="injecaoPlasticoBtnNext"
            onClick={nextSlide}
          />

          <FontAwesomeIcon
            icon={faCircleXmark}
            className="injecaoPlasticoBtnClose"
            onClick={handleCloseModal}
          />

          <img
            className="injecaoPlasticoFullScreenImage"
            src={listaInjecaoPlastico[slideNumber].img}
            alt="injecaoPlasticoImg"
          />
        </div>
      )}

      {/* LOGO */}
      <div className="img-custom-size img-fluid ms-2">
        <img src={logoImg} alt="logoInjecaoPlastico" />
      </div>

      {/* GALERIA */}
      <div className="injecaoPlasticoGalleryWrap mx-2">
        {listaInjecaoPlastico &&
          listaInjecaoPlastico.map((image, index) => (
            <div
              className="injecaoPlasticoSingle"
              key={index}
              onClick={() => handleOpenModal(index)}
            >
              <img src={image.img} alt="injecaoPlastico" />
            </div>
          ))}
      </div>

      {/* BOTÃO */}
      <div className="text-center text-nowrap my-4">
        <Link to="/Capabilities/Production">
          <button className="buttonCapabilities">
            {t("plastic.backToCapabilities")}
          </button>
        </Link>
      </div>
    </div>
  );
}

export default ImgInjecaoPlastico;
